
/**
 * 判断是否少字
 * @param {*} str1 （审计文本）
 * @param {*} str2 （申请文本）
 * 返回true为少字
 */
function shortCharacter(str1,str2) {
	let onoff=compare(str1,str2,0)
	return onoff
}
function compare(str1,str2,num=0){
	let str=match(str2[num],str1,str2);
	if(str=='相等'){
		num++
		if(num==str2.length){
			return false
		}
		return compare(str1,str2,num)
	}else if(str=='少字') {
		return true
	}
}
//获取一个字符串在另一个字符串出现的次数
function match(strIndex,str1,str2){
	let reg = eval(`/\\${strIndex}/igm`)
	let num1=str1.match(reg)&&str1.match(reg).length||0
	let num2=str2.match(reg)&&str2.match(reg).length||0
	if(num1==num2){
		return '相等'
	}else if(num1>num2){
		return '相等'
	}else {
		return '少字'
	}
}

/**
 * 判断是否多字
 * @param {*} str1 （审计文本）
 * @param {*} str2 （申请文本）
 * 返回true为多字
 */
function multiword(str1,str2) {
	let onoff=compare2(str1,str2,0)
	return onoff
}
function compare2(str1,str2,num=0){
	let str=match2(str1[num],str1,str2);
	if(str=='相等'){
		num++
		if(num==str2.length){
			return false
		}
		return compare2(str1,str2,num)
	}else if(str=='多字') {
		return true
	}
}
//获取一个字符串在另一个字符串出现的次数
function match2(strIndex,str1,str2){
	let reg = eval(`/\\${strIndex}/igm`)
	let num1=str1.match(reg)&&str1.match(reg).length||0
	let num2=str2.match(reg)&&str2.match(reg).length||0
	if(num1==num2){
		return '相等'
	}else if(num1>num2){
		return '多字'
	}else {
		return '相等'
	}
}

export default {
	shortCharacter,
	multiword
}


// WEBPACK FOOTER //
// ./static/js/function/str.js